/**
 * Transparent mirror layer that draws wavy underlines under claim sentences.
 * It renders the SAME text with the SAME metrics as the textarea it sits
 * behind, but fully transparent — only the decorations are visible.
 */
const STYLE = {
  supported: 'decoration-emerald-500',
  partial: 'decoration-amber-500',
  unsupported: 'decoration-rose-500',
};

export const claimSegments = (text, marks) => {
  const sorted = [...marks].filter((m) => m.end > m.start).sort((a, b) => a.start - b.start);
  const out = [];
  let pos = 0;
  sorted.forEach((m, i) => {
    const start = Math.max(pos, Math.min(m.start, text.length));
    const end = Math.max(start, Math.min(m.end, text.length));
    if (start > pos) out.push({ text: text.slice(pos, start), key: `p${i}` });
    if (end > start) out.push({ text: text.slice(start, end), mark: m, key: `m${i}` });
    pos = end;
  });
  if (pos < text.length) out.push({ text: text.slice(pos), key: 'tail' });
  return out;
};

export default function ClaimHighlightOverlay({ text, marks, className, style, innerRef }) {
  return (
    <div ref={innerRef} aria-hidden="true" style={style}
      className={`${className} absolute inset-0 overflow-hidden whitespace-pre-wrap break-words text-transparent pointer-events-none select-none`}
      data-testid="claim-highlight-overlay">
      {claimSegments(text, marks).map((seg) => (
        seg.mark
          ? <span key={seg.key}
            className={`underline decoration-wavy decoration-2 underline-offset-4 ${STYLE[seg.mark.verdict] || STYLE.partial}`}
            data-testid={`claim-mark-${seg.mark.verdict}`}>{seg.text}</span>
          : <span key={seg.key}>{seg.text}</span>
      ))}
    </div>
  );
}
